import { createRoute } from "apps/visits/packages/shared/models/Route";
import { t } from "i18next";

export const routes = {
  validateUser: createRoute("/"),
  thankYou: createRoute<{ uuid: string }>(`/:uuid/${t("VOUCHERS_DISTRIBUTION.ROUTES.THANK_YOU")}`),
  checkout: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CHECKOUT")}`),
  pickVoucher: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.PICK_VOUCHER")}`),
  codeValidation: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.CODE_VALIDATION")}`),
  pickUpsell: createRoute("/dokup-badania"),
  termsAgreement: createRoute(`/${t("VOUCHERS_DISTRIBUTION.ROUTES.TERMS_AGREEMENT")}`),
};
